module.exports = __webpack_public_path__ + "media/images/costumes/top/dress-brand-2-big-777fe6a5416433fd654a9e352670402f.jpg";